<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" label-width="80px">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_biz_user') || '业务员'"
            prop="fabricAgentCode"
          >
            <dict-select
              v-model="formData.fabricAgentCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.fabricAgentName"
              style="width: 100%"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  props: { fabricCodeList: { type: Array, default: () => [] } },
  data() {
    return {
      formData: { fabricAgentCode: '', fabricAgentName: '' },
      rules: {
        fabricAgentCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const confirm = await this.$confirm(
        this.$l('form_label_update_fabric_business_personnel') +
          this.formData.fabricAgentName +
          this.$l('form_label_symbol') ||
          '是否要将所选面料业务人员，更新为【' +
            this.formData.fabricAgentName +
            '】',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const params = { fabricCodeList: this.fabricCodeList, ...this.formData }
      const res = await this.$api
        .masterFabricChangeAgentApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '更新失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '更新成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style scoped></style>
